// extracted by mini-css-extract-plugin
module.exports = {"container":"Button-container-1ZdPG","colorWhite":"Button-colorWhite-3Wg3J","colorBlack":"Button-colorBlack-1mSqs"};